$.fn.nl_leaflet_map = function () {
    var $this = $(this);
    if ($this.length) {
        loadCSS("//cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.1/leaflet.css");
        $.getScript("//cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.1/leaflet.js")
            .done(function () {
                var $map_coords = $this.data("coords").split(/[\s,]+/);
        
                var map = L.map($this[0], {
                    center: $map_coords, zoom: $this.data("zoom"), scrollWheelZoom: false, dragging: false
                });
                $(".leaflet-control-zoom").css("visibility", "hidden");
                L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibHVib21pcmJsYXplayIsImEiOiJjaW9lYnR5bTcwMDFydXdreGxkdWR4MDh3In0.YSE0U9hP_E-dUrG2V7zieA', {
                    maxZoom: 18
                }).addTo(map);
        
                var map_icon = L.icon({
                    iconUrl: $this.data("marker"), iconSize: [64], iconAnchor: [32, 64]
                });
                
                L.marker($map_coords, {icon: map_icon}).addTo(map).on("click",function() {
                    window.open($this.data("map"));
                });
                        
                function onMapClick() {
                    map.scrollWheelZoom.enable();
                    map.dragging.enable();
                    $(".leaflet-control-zoom").css("visibility", "visible");
                    L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibHVib21pcmJsYXplayIsImEiOiJjaW9lYnR5bTcwMDFydXdreGxkdWR4MDh3In0.YSE0U9hP_E-dUrG2V7zieA', {
                        maxZoom: 18
                    }).addTo(map);
                    $this.addClass("mod--active");
                }

                $(document).on("click",function(e){
                    if ($(e.target).closest('.elm_map').length === 0 && $this.hasClass("mod--active")) {
                        map.scrollWheelZoom.disable();
                        map.dragging.disable();
                        $(".leaflet-control-zoom").css("visibility", "hidden");
                        L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibHVib21pcmJsYXplayIsImEiOiJjaW9lYnR5bTcwMDFydXdreGxkdWR4MDh3In0.YSE0U9hP_E-dUrG2V7zieA', {
                            maxZoom: 18
                        }).addTo(map);
                        $this.removeClass("mod--active");
                    }
                });
        
                map.on('click', onMapClick);
            });
    }
};